import React, { useMemo } from "react";
import {
  NewReportData,
  SchedulingPage,
} from "../../new-reports/types/newReportTypes";
import NewReportPagesContent from "../../new-reports/components/NewReportPagesContent";
import { calculateSchedulingPageCount } from "../../new-reports/hooks/usePagination";

type Props = {
  newData: NewReportData;
};

const ScaledNewReportPages = ({ newData }: Props) => {
  // Calculate total page count including scheduling pages
  const totalPageCount = useMemo(() => {
    return newData.pages.reduce((total, page) => {
      if (page.pageType === "cover") return total + 1;
      if (page.pageType === "scheduling") {
        // Calculate how many pages this scheduling section will take
        return total + calculateSchedulingPageCount(page as SchedulingPage);
      }
      if (page.pageType === "services") {
        return total + page.services.length;
      }
      return total;
    }, 0);
  }, [newData.pages]);

  return (
    <div
      style={{
        transform: "scale(1.3314)",
        transformOrigin: "top left",
        width: "595px",
        marginBottom: `${totalPageCount * 843 * 0.3314}px`, // Adjust spacing for scaled height: pageCount * 843px * (scale - 1)
      }}
    >
      <NewReportPagesContent data={newData} />
    </div>
  );
};

export default ScaledNewReportPages;
